<template>
  <v-card class="custom-text">
    <v-app-bar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('message.chat.header') }}</v-toolbar-title>
    </v-app-bar>
    <div id="chat-area">
      <div v-for="message in messages" :key="message.uuid" :id="message.uuid">
        <p
          class="message message-in"
          v-if="message.user === $t('message.videoCall.localTag')"
        >
          <b>{{ message.user }}</b
          ><br />
          {{ message.content }}
        </p>
        <p
          class="message message-out"
          v-if="message.user !== $t('message.videoCall.localTag')"
        >
          <b>{{ message.user }}</b
          ><br />
          {{ message.content }}
        </p>
        <div style="clear: both;" />
      </div>
    </div>
    <v-container id="text-input">
      <v-row>
        <v-col cols="9">
          <input
            id="text"
            class="input-text"
            type="text"
            :value="currentMessage"
            @input="inputChange"
            :placeholder="$t('message.chat.placeholder')"
            autofocus
            autocomplete="off"
          />
        </v-col>
        <v-col cols="3">
          <v-btn
            :disabled="!thereAreParticipants"
            fab
            color="success"
            v-on:click="sendMessage"
          >
            <v-icon>mdi-send</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: {
    messages: { type: Array },
    sendChatMessage: { type: Function },
    closeDialog: { type: Function },
    showMessage: { type: Function },
    thereAreParticipants: { type: Function }
  },
  mounted() {
    this.chatAreaElement = document.getElementById('chat-area');
    this.textInput = document.getElementById('text');
  },
  updated() {
    console.log('Updating...');
    this.scrollToEnd();
  },
  data: () => ({
    currentMessage: '',
    chatAreaElement: null,
    textInput: null
  }),
  methods: {
    sendMessage() {
      if (this.currentMessage === '') return;
      this.sendChatMessage(this.currentMessage);
      this.currentMessage = '';
      this.textInput.focus();
    },
    scrollToEnd() {
      this.chatAreaElement.scrollTop = this.chatAreaElement.scrollHeight;
    },
    inputChange(e) {
      this.currentMessage = e.target.value;
    }
  }
};
</script>

<style>
#text-input {
  position: absolute;
  bottom: 0;
  height: 90px;
}

.input-text {
  height: 50px;
  border-radius: 5px;
  border: 1px solid grey;
  background-color: white;
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
}

.message {
  max-width: 60%;
  min-width: 20%;
  border-radius: 10px;
  padding: 0.5em;
  font-size: 0.8em;
}

.message-out {
  background: #1776d1;
  color: white;
}

.message-in {
  background: #f1f0f0;
  color: black;
  float: right;
}

#chat-area {
  max-height: calc(100vh - 160px);
  padding: 1em;
  overflow: scroll;
  scroll-behavior: smooth;
}
</style>
